import type { ZudokuConfig } from "zudoku";
import {
  hasPortalPermissionDisplay,
  hasKeycompsPermissionDisplay,
  hasKeycompsPartnerPermissionDisplay,
  hasDealRoomPermissionDisplay,
  hasKeydocsPermissionDisplay,
} from "./permission-helpers";

const config: ZudokuConfig = {
  site: {
    title: "Keyway Developer Portal",
    logo: { src: { light: "/images/logo-light.svg", dark: "/images/logo-dark.svg" } },
  },
  metadata: { favicon: "/favicon.png", title: "Keyway Developer Portal" },

  navigation: [
    {
      type: "doc",
      file: "index",
      path: "/",
      label: "Index",
      display: "always",
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
      display: hasKeycompsPermissionDisplay(),
    },
    {
      type: "link",
      to: "/partner-api",
      label: "Partner API Reference",
      display: hasKeycompsPartnerPermissionDisplay(),
    },
    {
      type: "link",
      to: "/deal-room-api",
      label: "Deal Room API Reference",
      display: hasDealRoomPermissionDisplay(),
    },
    {
      type: "link",
      to: "/keydocs-api",
      label: "KeyDocs API Reference",
      display: hasKeydocsPermissionDisplay(),
    },
  ],
  apis: [
    {
      type: "file",
      input: "./specs/routes.oas.json",
      path: "/api",
    },
    {
      type: "file",
      input: "./specs/partner-routes.oas.json",
      path: "/partner-api",
    },
    {
      type: "file",
      input: "./specs/deal-room-routes.oas.json",
      path: "/deal-room-api",
    },
    {
      type: "file",
      input: "./specs/keydocs-routes.oas.json",
      path: "/keydocs-api",
    },
  ],
  docs: {
    files: "/pages/**/*.{md,mdx}"
  },

  protectedRoutes: {
    "/admin/*": hasPortalPermissionDisplay(),
    "/settings": hasPortalPermissionDisplay(),
    "/": hasPortalPermissionDisplay(),
    "/docs/*": hasPortalPermissionDisplay(),
    "/api": hasKeycompsPermissionDisplay(),
    "/api/*": hasKeycompsPermissionDisplay(),
    "/partner-api": hasKeycompsPartnerPermissionDisplay(),
    "/partner-api/*": hasKeycompsPartnerPermissionDisplay(),
    "/deal-room-api": hasDealRoomPermissionDisplay(),
    "/deal-room-api/*": hasDealRoomPermissionDisplay(),
    "/keydocs-api": hasKeydocsPermissionDisplay(),
    "/keydocs-api/*": hasKeydocsPermissionDisplay(),
  },

  authentication: {
    type: "auth0",
    clientId: process.env.ZUDOKU_PUBLIC_AUTH0_CLIENT_ID!,
    domain: process.env.ZUDOKU_PUBLIC_AUTH0_DOMAIN!,
    audience: process.env.ZUDOKU_PUBLIC_AUTH0_AUDIENCE!
  },
};
export default config;
